import { API_PATHS } from "../../../config/ApiPaths";
import { TYPE_SABAY_GAME_REVENUE } from "./type";

export const getDataRevenueSabayGame = (url) => {
  return {
    type: TYPE_SABAY_GAME_REVENUE,
    meta: {
      url,
      method: "GET",
    },
  };
};


